(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/utils/dialogs.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/utils/dialogs.js');

'use strict';

const notActiveMemberProlongDialog = () => {
  const dialog = new svs.ui.dialog.Confirm({
    icon: 'exclamation-sign',
    allowDimmerClick: true,
    branding: svs.ui.dialog.branding.TUR,
    type: svs.ui.dialog.type.INFO,
    title: 'Hoppsan!',
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text: 'Du vill förlänga ett lagspel där du inte längre är medlem. Vi ändrar så du betalar från ditt eget spelkonto.'
    }],
    actions: [{
      title: 'OK'
    }]
  });
  svs.ui.dialog.api.add(dialog);
};
const showJokerDialog = () => {
  const dialog = new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    icon: 'exclamation-sign',
    title: 'Spelstopp Joker har passerat',
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text: 'Du kan inte förlänga spelet med Joker just nu. Du kan förlänga spelet utan Joker.'
    }],
    actions: [{
      title: 'Ok'
    }]
  });
  svs.ui.dialog.api.add(dialog);
};
const showNumRowsExceedMaxDialog = wager => {
  const dialog = new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    icon: 'exclamation-sign',
    area: svs.ui.dialog.area.POPUP,
    convertToPopup: false,
    allowDimmerClick: false,
    title: 'Ditt spel har många rader',
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text: "Ditt spel inneh\xE5ller fler rader \xE4n vi erbjuder f\xF6r enkelrader online.\n                Du kan f\xF6rl\xE4nga ".concat(wager.get('boards').rules.maxNumberOfRows, " rader med m\xF6jlighet att \xE4ndra i spelet.\n                Alternativt kan du f\xF6rl\xE4nga spelet utan \xE4ndringar via \"F\xF6rl\xE4ng\" p\xE5 ").concat(svs.numbergames.productMapping.getProductName(wager.get('productId')), "-sidan")
    }],
    actions: [{
      title: 'Ändra'
    }, {
      title: 'FÖRLÄNG UTAN ÄNDRING',
      callback: () => {
        dialog.close();
        Backbone.history.navigate('forlang-spel', {
          trigger: true
        });
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
};
svs.numbergames.game.utils.dialogs = {
  notActiveMemberProlongDialog,
  showJokerDialog,
  showNumRowsExceedMaxDialog
};

 })(window);